import React from 'react'
import PropTypes from 'prop-types'
import { StarRating } from './StarRating'
import { ReviewCount } from 'components/common/rating'

export interface RatingProps {
  rating: number // TODO: Make this stricter
  reviewCount: number
}

export function Rating ({ rating, reviewCount }: RatingProps): React.ReactElement {
  const starRating = rating * 10
  return (
    <div className='rating'>
      <span className='overall-rating'>{rating.toFixed(1)}</span>
      <ReviewCount reviewCount={reviewCount}>
        <StarRating rating={starRating} />
      </ReviewCount>
    </div>
  )
}

Rating.propTypes = {
  rating: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired
}
